/**
 * Used to control a locked product tile view of preorderable products and IDV flow
 */
export const PREORDER_IDV_SELF_SUBMIT = 'PREORDER_IDV_SELF_SUBMIT';
